import { environment } from '@environment';

declare global {
  interface Window {
    environment: typeof import('../app/environments/environment').environment;
  }
}
export function prepareApp(): Promise<void> {
  return new Promise((resolve) => {
    if (environment.mockServiceWorker.enabled) {
      import('./browser').then(({ worker }) => {
        worker
          .start({
            serviceWorker: {
              url: `${environment.mockServiceWorker.baseUrl}/mockServiceWorker.js`.toLocaleLowerCase(),
              options: {
                scope: `/`.toLocaleLowerCase(),
              },
            },
          })
          .then(() => {
            if (navigator.serviceWorker.controller) {
              navigator.serviceWorker.controller.postMessage({ environment });
            }
            resolve();
          });
      });
    } else {
      resolve();
    }
  });
}
